import { ElementRef, HostListener, Directive } from '@angular/core';

@Directive({
	selector: '[copoInputText]',
})
export class TextFieldDirective {
	constructor(private readonly elRef: ElementRef<HTMLInputElement>) {}
	@HostListener('input', ['$event']) onInputChange() {
		const initalValue = this.elRef.nativeElement.value;
		this.elRef.nativeElement.value = initalValue.replace(/[^\d #$%()*+,./:=?A-Z_°µÂÄÜâäü-]*/g, '');
	}
}
